// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 6158) return "static/chunks/6158-87620f46c159e019.js";
	if (chunkId === 8139) return "static/chunks/8139-853f3f4419bb261a.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"3179":"3ddc9f734b79f5cf","5560":"992e7c4a390b743f","6264":"7443804115fa3e1e","7573":"b3748590a4b6c27d"}[chunkId] + ".js";
};